export { TrBrandMerchandiseCard } from './TrBrandMerchandiseCard';
